class EventUtils {
    static isLeftClickEvent(event) {
        return event.button === 0;
    }

    static isModifiedEvent(event) {
        return !!(
            event.metaKey ||
            event.altKey ||
            event.ctrlKey ||
            event.shiftKey
        );
    }

    static stopPropagation(event) {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
    }
}

export default EventUtils;
